import EditTemplates from './EditTemplates'

export default EditTemplates
